import React from "react";
import { formatSecondsToDuration } from "@tvg/formatter/dates";
import { UnaryFn } from "@tvg/ts-types/Functional";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fanduelPlayIcon } from "@fdr/static-ui/Icons/icons";
import { JWPlayerAPITracks } from "@fdr/video-builder/src/types";
import {
  VideoCardWrapper,
  VideoPlayerContainer,
  Description,
  Title,
  Row,
  Label,
  VideoDuration,
  PlayIcon
} from "./styled-components";

export interface VideoCardProps {
  description: {
    title: string;
    description: string;
    category?: string;
    uploadedAt: string;
  };
  video: {
    playerId: string;
    playerScript?: string;
    licenseKey?: string;
    src: string;
    thumbnail?: string;
    duration: number;
    tracks?: JWPlayerAPITracks[];
    height?: number;
    width?: number;
  };
  onClick?: UnaryFn<VideoCardProps, void>;
}

export function VideoCard({ description, video, onClick }: VideoCardProps) {
  return (
    <VideoCardWrapper
      data-qa-label={`videoCard-${video.playerId}`}
      onClick={() => onClick?.({ description, video })}
    >
      <VideoPlayerContainer image={video.thumbnail}>
        <VideoDuration>
          {formatSecondsToDuration(video.duration).substring(0, 5)}
        </VideoDuration>
        <PlayIcon
          icon={fanduelPlayIcon}
          size={48}
          colorList={[buildColor("white"), buildColor("blue")]}
          viewBoxSize="48"
        />
      </VideoPlayerContainer>
      <Description>
        <Title>{description.title}</Title>
        <Row>
          <Label>{description.category}</Label>
          <Label>{description.uploadedAt}</Label>
        </Row>
      </Description>
    </VideoCardWrapper>
  );
}

export default VideoCard;
